<template>
    <TopBg :showBg="!$web.isDesktop">

        <h1 class="desktop-title" v-if="$web.isDesktop">
            Accedi
        </h1>

        <!-- Top logo -->
        <TopLogo :white="true" v-if="!$web.isDesktop"/>

        <div class="d-flex flex-column justify-content-between h-75 pt-4 page-content"
            :class="{'desktop-card desktop-card-small':$web.isDesktop}">

            <!-- Login title -->
            <div v-text="contents.title" class="login-title" v-if="!$web.isDesktop"/>

            <!-- Facebook button -->
            <Btn @click="facebookLogin"
                 type="facebook"
                 :text="contents.facebook_login"/>

            <!-- Or -->
            <div v-text="contents.or" class="or"/>

            <div>
                <!-- Email label -->
                <label v-text="contents.email_login"
                       for="email" class="email-label"/>

                <!-- Email input -->
                <TextInput
                        type="email" id="email"
                        :value="email" @input="email = $event.value"
                        :placeholder="contents.your_email"/>

                <!-- Privacy check -->
                <CheckBox v-model="privacy" :label="contents.privacy" class="mb-2"/>

                <!-- Newsletter check -->
                <CheckBox v-model="newsletter" :label="contents.newsletter" class="mb-4"/>

                <!-- Continue button -->
                <Btn :text="buttonText" @click="emailLogin" :disabled="!email"/>

                <a :href="$options.consts.VUE_APP_PRIVACY_LINK"
                   target="_blank"
                   class="privacy-link"
                   v-text="contents.privacy_link"></a>

            </div>

        </div>
    </TopBg>
</template>

<script>
    import contents from "../contents/login.json"
    import TopBg from "../components/TopBg"
    import TopLogo from "../components/TopLogo"
    import Btn from "../components/Btn";
    import TextInput from "../components/TextInput";
    import CheckBox from "../components/CheckBox";
    import {emailIsValid} from "@/helpers";

    const {VUE_APP_PRIVACY_LINK} = process.env;

    export default {
        consts: {
            VUE_APP_PRIVACY_LINK
        },
        name: 'login',
        components: {TextInput, Btn, TopBg, TopLogo, CheckBox},
        mounted() {
            // Access from clicking on "Accedi"
            this.deliberateAccess = this.$route.query.deliberateAccess

            this.$registerEvent('Pagina', '6. Login');
        },
        data() {
            return {
                contents,
                email: this.$store.state.subscriber_email,
                newsletter: this.$store.state.newsletter_subscription,
                privacy: false,
                deliberateAccess: false
            };
        },
        methods: {
            async facebookLogin() {
                let token = await this.$facebookLogin();
                await this.$api.loginWithFacebook(token);
                this.$registerEvent('Azione', 'Utente registrato tramite Facebook');
                this.$registerFacebookEvent('CompleteRegistration')

                this.$redirectAfterLogin();
            },
            async emailLogin() {
                if (!this.emailIsValid()) {
                    return this.$alert(contents.email_validation_error);
                }
                if (!this.privacy) {
                    return this.$alert(contents.privacy_error);
                }

                await this.$api.sendPinByEmail(this.email, this.newsletter);

                this.$store.commit('setSubscriberEmail', this.email);
                this.$store.commit('setNewsletterSubscription', this.newsletter);
                await this.$router.push('/verify_pin');
            },
            emailIsValid() {
                return emailIsValid(this.email)
            }
        },
        computed: {
            buttonText(){
                return !this.deliberateAccess
                    ? this.contents.continue
                    : this.contents.continue_alt
            }
        }
    };
</script>

<style scoped lang="scss">
    @import '../styles/colors.scss';

    .page-content {
        max-height: 600px;
    }

    .login-title {
        font-weight: bold;
        font-size: 18px;
        line-height: 27px;
        text-align: center;
        color: $darkGrey;
        padding: 0 60px;
        margin: 0 0 20px;
    }

    .or {
        font-family: "Open Sans";
        font-weight: 400;
        font-size: 14px;
        line-height: 19px;
        text-align: center;
        color: $darkGrey;
        text-transform: lowercase;
        margin: 20px 0;
    }

    .email-label {
        font-family: "Poppins";
        font-weight: bold;
        font-size: 18px;
        line-height: 27px;
        text-align: center;
        display: block;
        color: $darkGrey;
    }

    .privacy-link {
        text-align: center;
        padding: 10px;
        display: block;
        color: $darkGreen;
    }
</style>
